import React from "react";
import { Form, Select } from "semantic-ui-react";
import PropTypes from "prop-types";

/**
 * Email provider selector component with dynamic "From" field based on provider type
 */
const EmailProviderSelector = ({
  // Provider state
  providerOptions,
  providerState,
  onProviderChange,
  disabled = false,

  // Sender fields
  senderName,
  onSenderNameChange,

  // From field props
  fromUser,
  onFromUserChange,
  fromDomain,
  errorMessage,

  // SMTP props
  isSMTP,
  smtpOptions,
  smtp_config_id,
  onSmtpChange,

  // Outlook props
  isOutlook,
  outlookEmailAliases,
  outlookAliasSelected,
  onOutlookAliasChange,

  // Mailgun props
  isMailgun,
  mailgunDomainOptions,
  mailgunDomainSelected,
  onMailgunDomainChange,
}) => {
  let usernameField = (
    <>
      <Form.Input
        name="fromUser"
        label="From"
        placeholder="ex. username"
        value={fromUser}
        onChange={onFromUserChange}
        required
        readOnly={isSMTP}
        error={!!errorMessage}
      />
      <div
        style={{ paddingTop: "2rem", marginLeft: "-1rem" }}
        hidden={!fromDomain || isSMTP}
      >
        <p>{`@${fromDomain}`}</p>
      </div>
    </>
  );

  if (isSMTP) {
    usernameField = (
      <Form.Field
        required
        control={Select}
        label="From"
        options={smtpOptions}
        onChange={onSmtpChange}
        value={smtp_config_id}
      />
    );
  } else if (isOutlook) {
    usernameField = (
      <Form.Select
        name="outlookAliasSelected"
        selection
        label="Select an alias"
        options={outlookEmailAliases}
        onChange={onOutlookAliasChange}
        value={outlookAliasSelected}
        required
      />
    );
  } else if (isMailgun) {
    usernameField = (
      <>
        <Form.Input
          label="From"
          placeholder="ex. username"
          onChange={onFromUserChange}
          name="fromUser"
          value={fromUser}
          error={!!errorMessage}
        />
        @
        <Form.Select
          name="mailgunDomainSelected"
          selection
          label="Select a domain"
          options={mailgunDomainOptions}
          onChange={onMailgunDomainChange}
          value={mailgunDomainSelected}
          required
        />
      </>
    );
  }

  return (
    <>
      <Form.Select
        selection
        required
        label="Email Provider"
        options={providerOptions}
        placeholder="Select an Email Provider"
        onChange={onProviderChange}
        value={providerState}
        disabled={disabled}
      />

      <Form.Group widths="equal">
        <Form.Input
          required
          label="Sender Name"
          placeholder="Type in Sender Name"
          onChange={onSenderNameChange}
          name="senderName"
          value={senderName}
        />
        {usernameField}
      </Form.Group>
    </>
  );
};

EmailProviderSelector.propTypes = {
  providerOptions: PropTypes.array.isRequired,
  providerState: PropTypes.string,
  onProviderChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  senderName: PropTypes.string.isRequired,
  onSenderNameChange: PropTypes.func.isRequired,
  fromUser: PropTypes.string.isRequired,
  onFromUserChange: PropTypes.func.isRequired,
  fromDomain: PropTypes.string,
  errorMessage: PropTypes.string,
  isSMTP: PropTypes.bool.isRequired,
  smtpOptions: PropTypes.array,
  smtp_config_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onSmtpChange: PropTypes.func,
  isOutlook: PropTypes.bool.isRequired,
  outlookEmailAliases: PropTypes.array,
  outlookAliasSelected: PropTypes.string,
  onOutlookAliasChange: PropTypes.func,
  isMailgun: PropTypes.bool.isRequired,
  mailgunDomainOptions: PropTypes.array,
  mailgunDomainSelected: PropTypes.string,
  onMailgunDomainChange: PropTypes.func,
};

export default EmailProviderSelector;
